const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.6133,
    y1: 8802.7627,
    x2: -72.4566,
    y2: 8468.6934,
    gradientTransform: "matrix(1 0 0 -1 0 8834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    style: {
      stopColor: "#00A2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M35.395,7.913c-5.789,6.127-9.212,15.64-9.212,27.966v440.242   c0,12.336,3.424,21.839,9.212,27.966l1.473,1.435l246.615-246.613v-2.908v-2.91L36.868,6.468L35.395,7.913z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127741872524441010550000008292814545950070690_",
    gradientUnits: "userSpaceOnUse",
    x1: 501.1742,
    y1: 8577.9902,
    x2: 19.5119,
    y2: 8577.9902,
    gradientTransform: "matrix(1 0 0 -1 0 8834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127741872524441010550000008292814545950070690_)"
    },
    d: "M365.683,341.149l-82.2-82.24v-2.908   v-2.91l82.219-82.219l1.853,1.057l97.396,55.341c27.821,15.805,27.821,41.667,0,57.482l-97.396,55.341L365.683,341.149z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032631701217109851430000017522047380022634658_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.8728,
    y1: 8532.3125,
    x2: -131.1525,
    y2: 8079.2876,
    gradientTransform: "matrix(1 0 0 -1 0 8834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3743"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E30864"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032631701217109851430000017522047380022634658_)"
    },
    d: "M367.556,340.082l-84.073-84.081   L35.395,504.087c9.173,9.708,24.309,10.91,41.367,1.222L367.556,340.082"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068646739207452442920000008036861086483792307_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.0711,
    y1: 8972.6309,
    x2: 175.2237,
    y2: 8770.3359,
    gradientTransform: "matrix(1 0 0 -1 0 8834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A06F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#00A86E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#00CF6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#00E76D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00EF6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068646739207452442920000008036861086483792307_)"
    },
    d: "M367.556,171.918L76.762,6.691   C59.704-2.997,44.568-1.795,35.395,7.913l248.088,248.088L367.556,171.918z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.63e9e262.svg";
export { ForwardRef as ReactComponent };